import { PRIMARY_NAV_CLICK } from '../constants';

export interface NavAction {
    type: 'NAV_CLICK';
}
export type NavActions = NavAction;
export type NavClick = (navId: string) => void;
export type ProfileNavClick = (navId: string, disabled: boolean) => void;

export const primaryNavClick = (navId: string, disabled: boolean) => {
    return function (dispatch: Function) {
        dispatch({
            type: PRIMARY_NAV_CLICK,
            payload: {
                navId
            }
        });
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/action/primaryNavActions.ts